
export function handleError(error: any, enqueueSnackbar: any) {
    if(error) {
        enqueueSnackbar(error.message, {variant: 'error', autoHideDuration: 5000})
    }
}
